export const PROPOSAL_STEP_NEGOTIATIONS = 'NEGOTIATIONS';
export const PROPOSAL_STEP_MATERIALS_EXCHANGE = 'MATERIALS_EXCHANGE';
export const PROPOSAL_STEP_MONITORING = 'MONITORING';

export type ProposalStep =
  | typeof PROPOSAL_STEP_NEGOTIATIONS
  | typeof PROPOSAL_STEP_MATERIALS_EXCHANGE
  | typeof PROPOSAL_STEP_MONITORING;

export const MATERIAL_TEST_STATUS_PENDING = 'PENDING';
export const MATERIAL_TEST_STATUS_CORRECTION_REQUESTED =
  'CORRECTION_REQUESTED';
export const MATERIAL_TEST_STATUS_ACCEPTED = 'ACCEPTED';

export type MaterialTestStatus =
  | typeof MATERIAL_TEST_STATUS_PENDING
  | typeof MATERIAL_TEST_STATUS_CORRECTION_REQUESTED
  | typeof MATERIAL_TEST_STATUS_ACCEPTED;
